export default function SettingsPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-gray-900">Settings</h1>
      
      <div className="card">
        <div className="card-content">
          <p className="text-gray-600">Settings functionality coming soon...</p>
        </div>
      </div>
    </div>
  );
} 